import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { TABS } from '../../../constants';
interface GiftTabContentDeliveryProps {
  deliveryCompanyName?: string;
}
export const GiftTabContentDelivery = t0 => {
  const $ = _c(12);
  const {
    deliveryCompanyName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex flex-col gap-64 px-0 pb-120", "mobile-tablet:gap-32 mobile-tablet:px-20 mobile-tablet:pb-60");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className={cn("pb-16 pt-32 text-[40px] font-600 text-Gray-900", "mobile-tablet:pb-8 mobile-tablet:pt-16 mobile-tablet:typo-body1")}>구매/배송</h2>;
    t3 = cn("mb-32 text-[28px] font-400 text-Gray-600", "mobile-tablet:mb-16 mobile-tablet:typo-body4");
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className={t3}>주문하신 상품은 3일 이내에 출고가 시작될 예정입니다.<br />물류 상황에 따라 배송이 지연될 수 있음을 양해 부탁드립니다.</p>;
    t5 = cn("flex flex-col border-t border-Gray-200 text-[28px] font-400 text-Gray-600 [&>li>p]:w-184 [&>li>span]:flex-1 [&>li>span]:font-500 [&>li>span]:text-Gray-700 [&>li]:border-b [&>li]:border-Gray-200 [&>li]:py-18", "mobile-tablet:typo-body4 mobile-tablet:[&>li>p]:w-92 mobile-tablet:[&>li]:py-10");
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== deliveryCompanyName) {
    t6 = deliveryCompanyName ? <li className="flex items-center gap-16"><p>배송방법</p><span>{deliveryCompanyName}</span></li> : null;
    $[5] = deliveryCompanyName;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li className="flex items-center gap-16"><p>배송 지역</p><span>전국</span></li>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <li className="flex items-center gap-16"><p>배송비</p><span>무료</span></li>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <li className="flex items-center gap-16"><p>배송 기간</p><span>상품 출고 후 영업일 기준 1~3일 이내 수령이 가능하며 도서 산간 지역이거나 택배사의 물량이 많은 경우 조금 더 소요될 수 있습니다.</span></li>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t6) {
    t10 = <section className={t1} id={TABS.DELIVERY}><article className="flex flex-col">{t2}{t4}<ul className={t5}>{t6}{t7}{t8}{t9}</ul></article></section>;
    $[10] = t6;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  return t10;
};